import { isString, isArguments } from 'lodash-es'
import { normalizeError, type ContextualizedError } from '#app/lib/error'
import { reportError } from '#app/lib/reports'
import { getTruthy } from '#app/lib/utils'

export function log (obj: unknown, label?: string) {
  // customizing console.log
  // unfortunatly, it makes the console loose the trace
  // of the real line and file the info function was called from
  // the trade-off might not be worthing it...
  if (isString(obj)) {
    if (label != null) console.log(`[${label}] ${obj}`)
    else console.log(obj)
  } else {
    // logging arguments as arrays for readability
    if (isArguments(obj)) obj = Array.from(obj)
    if (label != null) console.log(`===== ${label} =====`)
    console.log(obj)
    if (label != null) console.log('-----')
  }

  return obj
}

export const info = log

export function logError (_err: unknown, label?: string) {
  let err = normalizeError(_err)
  // The previous 'err instanceof Error' now fails
  // as it seems that instances of TypeError aren't considered
  // instances of Error anymore
  if (!(err.constructor?.name?.endsWith('Error'))) {
    const errData = err
    err = new Error('invalid error object')
    err.context = errData
    // Non-standard convention: 599 = client implementation error
    err.statusCode = 599
    reportError(err)
    throw err
  }

  let userError = false
  if (err.statusCode != null) {
    if (/^4\d+$/.test(err.statusCode.toString())) userError = true
  }

  // No need to report user errors to the server
  // This statusCode can be set from the client for this purpose
  // of not reporting the error to the server
  if (userError) {
    return console.error(`[${err.statusCode}]${label ? `[${label}]` : ''} ${err.message}`)
  }

  // No need to report server error back to the server
  if (!err.serverError && !getTruthy(err.cause, 'serverError')) reportError(err)

  const loggerArgs = []
  if (label) loggerArgs.push(`[${label}]\n`)
  loggerArgs.push(err)
  if (err.context) loggerArgs.push(err.context)
  console.error(...loggerArgs)
}

export function warn (obj: unknown, label?: string) {
  console.warn('/!\\')
  log(obj, label)
}

export function logServer (obj: unknown, label: string) {
  // Using native fetch promise instead of preq to be able to report errors
  // happening before preq is initialized
  // Not import #app/lib/api/api.ts API.tests to avoid depending on the app object in tests env
  fetch('/api/tests', {
    method: 'post',
    headers: { 'content-type': 'application/json' },
    body: JSON.stringify({ obj, label }),
  })
  return obj
}

export function LogError (label: string) {
  return function (err: ContextualizedError) {
    return logError(err, label)
  }
}
